module.exports = __webpack_public_path__ + "img/gs.4dfb464b.svg";